import { logError } from '@/providers/ErrorTracking';

type Field = 'sign-up-title' | 'sign-up-name-label' | 'sign-up-name-placeholder';

type Props = {
  field: Field;
  isCreator?: boolean;
  creatorSlug?: string | null; // @todo creator would be better....
};

const pickText = ({ field, isCreator, creatorSlug }: Props): string => {
  if (field === 'sign-up-title') {
    if (isCreator) {
      return 'Create your Glade account';
    }
    return 'Sign up';
  }

  if (field === 'sign-up-name-placeholder') {
    if (creatorSlug === 'compleximmigration') {
      return 'Name (your name or the business/organization name)';
    }
    return 'Enter your name';
  }

  if (field === 'sign-up-name-label') {
    if (creatorSlug === 'compleximmigration') {
      return 'Your name or the business/organization name';
    }
    return 'Your name';
  }

  logError(new Error('Unexpected field when picking text'), { field });
  return '';
};

export default pickText;
